// extracted by mini-css-extract-plugin
export default {"wrapper":"UserInfo_wrapper__fliyk","fullName":"UserInfo_fullName__G+NWi","studyInfo":"UserInfo_studyInfo__k9Ak9"};